const SPINNER_ID = 'mobile-spinner-overlay';

export default class loadingMobileService {

  /**
   * @name loadingMobileService
   * @module common.services
   * @description
   * A wrapper for a loading dialog.
  * By default it does nothing, but in mobile flows it can show a web overlay spinner.
   *
   * @usage
   * ```js
   * //show a loading dialog
   * loadingMobileService.show();
   * this.loansOperationsService.getCreditworthiness(this.userId).then(creditworthiness => {
   *   //do whatever you want
   * }, error => {
   *   //do whatever you want
   * }).finally(()=> {
   * //when everything is done, hide the loading dialog
   *   this.loadingMobileService.hide();
   * });
   * ```
   */
  constructor() {
    'ngInject';

    this.show = () => {};
    this.hide = () => {};

    this.show = () => {
      if (document.getElementById(SPINNER_ID)) return;
      const overlay = document.createElement('div');
      overlay.id = SPINNER_ID;
      overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center;z-index:99999';
      overlay.innerHTML = '<div style="width:48px;height:48px;border:5px solid #fff;border-top-color:transparent;border-radius:50%;animation:spin 0.8s linear infinite"></div><style>@keyframes spin{to{transform:rotate(360deg)}}</style>';
      document.body.appendChild(overlay);
    };
    this.hide = () => {
      const overlay = document.getElementById(SPINNER_ID);
      if (overlay) overlay.parentNode.removeChild(overlay);
    };
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/loading.mobile.service.js